import styles from "./index.module.css";

interface WaitListItemInfoProps {
    title: string
    content: string
}

const WaitListItemInfo: React.FC<WaitListItemInfoProps> = ({ title, content }) => {

    return (
        <div className={styles.wait_list_item_info}>
            <p>{title}</p>
            <p>{content}</p>
        </div>
    );

}

export default WaitListItemInfo;